module.exports = __webpack_public_path__ + "static/media/get-returns-icon.1eadc70c.svg";